module finadai.app.register {
  export var NAME = 'finadai.app.register';
  interface RegisterField{
    label: string;
    name: string;
    inputType: string;
    icon: any;
    help?: string;
  }
  function RegisterController($scope, customersService: finadai.services.CustomersService, notify, $stateParams, appConfig, $mdDialog: ng.material.IDialogService, $state: ng.ui.IStateService){
    $scope.registerData = { customer_code: $stateParams.customerCode };
    var fields:Array<RegisterField> = $scope.fields = [
      { label: 'Nombre',           name: 'name',             inputType: 'text',      icon: 'perm_identity',  help: 'Sin abreviaciones'},
      { label: 'Apellido Paterno',    name: 'last_name',        inputType: 'text',      icon: '',               help: 'Sin abreviaciones'},
      { label: 'RFC',                 name: 'rfc',              inputType: 'text',      icon: 'verified_user'},
      { label: 'Email',               name: 'email',            inputType: 'email',     icon: 'mail_outline'},
      { label: 'Celular',             name: 'phone',            inputType: 'text',      icon: 'local_phone',    help: 'Incluir lada, sin símbolos, 10 dígitos.' },
      { label: 'Password',            name: 'password',         inputType: 'password',  icon: 'lock_outline',  help: 'Minimo 6 Caracteres.'},
      { label: '',                    name: 'customer_number',  inputType: 'hidden',    icon: ''},
    ];

    $scope.registerData['name'] = $stateParams.name;
    $scope.registerData['last_name'] = $stateParams.last_name;
    $scope.registerData['rfc'] = $stateParams.rfc;
    $scope.registerData['customer_number'] = $stateParams.customer_number;

    $scope.sended = false;
    $scope.loading = false;
    $scope.submit = (form) => {
      $scope.success = false;
      if(form.$valid){
        $scope.loading = true;
        customersService.proxyRegister($scope.registerData).then((response:any) => {
          $scope.loading = false;
          $scope.sended = true;
          if(angular.isDefined(response.data.error)){
            $scope.message = { type: 'warning', text: 'No se encontró registro de cliente, favor de comunicarse vía chat.' };
          }
          else{
            $state.go('registerSuccess');
          }
        }, responseError => {
          $scope.loading = false;
          $scope.sended = true;
          $scope.message = { type: 'danger', text: 'Ocurrió un error al tratar de enviar su información, favor de comunicarse vía chat.' };
        })
      }
    }

    $scope.showTerms = (ev) => {
      $mdDialog.show({
        templateUrl: 'app/layout/terms.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: false // Only for -xs, -sm breakpoints.
      });
    }
  }
  export function run() {
    var register = angular.module(NAME, []);
    register.controller('RegisterController', RegisterController); 
  }
}
finadai.app.register.run();